import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { UserContextService } from '../../auth/user-context.service';

@Component({
  selector: 'app-subnav',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, MatIconModule],
  template: `
    <nav class="subnav" role="navigation" aria-label="Navigation principale">
      <a routerLink="/traites" routerLinkActive="active" class="nav-tab">
        <mat-icon>description</mat-icon>
        <span>Traités juridiques</span>
      </a>
      <a routerLink="/marques" routerLinkActive="active" class="nav-tab">
        <mat-icon>business</mat-icon>
        <span>Marques</span>
      </a>
      <a routerLink="/audit" routerLinkActive="active" class="nav-tab">
        <mat-icon>history</mat-icon>
        <span>Historique</span>
      </a>
      @if (userCtx.isAdmin) {
        <a routerLink="/configuration" routerLinkActive="active" class="nav-tab">
          <mat-icon>settings</mat-icon>
          <span>Configuration</span>
        </a>
      }
    </nav>
  `,
  styles: [`
    :host { display: block; background: white; border-bottom: 1px solid #E0E0E0; }

    .subnav {
      display: flex;
      align-items: flex-end;
      padding: 0 20px;
      height: 44px;
      gap: 4px;
    }

    .nav-tab {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      padding: 0 16px;
      height: 40px;
      color: #757575;
      text-decoration: none;
      font-size: 14px;
      font-weight: 500;
      border-bottom: 3px solid transparent;
      border-radius: 4px 4px 0 0;
      transition: background 0.15s, color 0.15s, border-color 0.15s;

      mat-icon { font-size: 18px; height: 18px; width: 18px; }

      &:hover {
        color: #0064A0;
        background: rgba(0, 100, 160, 0.04);
      }

      &.active {
        color: #0064A0;
        border-bottom-color: #0064A0;
        background: rgba(0, 100, 160, 0.05);
      }
    }
  `],
})
export class SubNavComponent {
  protected readonly userCtx = inject(UserContextService);
}
